import ResourceManager from "@/components/app/ResourceManager";
import { Badge } from "@/components/ui/badge";

const config = {
  endpoint: "products",
  testid: "products",
  singular: "Product",
  overline: "Loan Backend",
  title: "Loan Products",
  subtitle: "Loan products mapped to lenders.",
  accent: "loan",
  perms: { add: "products.add", edit: "products.edit", delete: "products.delete" },
  columns: [
    { key: "product_name", label: "Product", render: (r) => <span className="font-medium text-zinc-900">{r.product_name}</span> },
    { key: "product_id", label: "Product ID", badge: true },
    { key: "product_type", label: "Type" },
    { key: "active", label: "Status", render: (r) => (
      <Badge variant="outline" className={`rounded-sm font-normal ${r.active ? "border-emerald-500 text-emerald-600" : "border-zinc-300 text-zinc-400"}`}>{r.active ? "Active" : "Inactive"}</Badge>
    )},
  ],
  fields: [
    { name: "product_name", label: "Product Name", type: "text", required: true, colSpan: 2 },
    { name: "lender_id", label: "Lender", type: "select", optionsEndpoint: "lenders", optionValue: "id", optionLabel: "name" },
    { name: "product_type", label: "Product Type", type: "select", options: ["Personal Loan", "Business Loan", "Home Loan", "LAP", "Car Loan", "Credit Card", "Other"].map((v) => ({ value: v, label: v })) },
    { name: "active", label: "Active", type: "switch" },
  ],
};

export default function Products() {
  return <ResourceManager config={config} />;
}
